/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react"
import { Divider } from "@mui/material"
import { StyledPrefixText } from "./styles"

export const RowGuestView = ({ data, showEmail, index, totalCount }) => {

  return (
    <React.Fragment>
      {
        (data?.first_name || data?.last_name) && (
          <p><StyledPrefixText>Name: </StyledPrefixText>{data?.first_name} {data?.last_name}</p>
        )
      }

      {
        (data?.name) && (
          <p><StyledPrefixText>Name: </StyledPrefixText>{data?.name}</p>
        )
      }

      {
        data?.phone_number && (
          <p><StyledPrefixText>Phone: </StyledPrefixText>{data?.phone_number}</p>
        )
      }

      {
        (data?.email && showEmail) && (
          <p><StyledPrefixText>Email: </StyledPrefixText>{data?.email}</p>
        )
      }

      {
        !(data?.first_name || data?.last_name) && !data?.name && !data?.phone_number && !(data?.email && showEmail) && (
          <p>—</p>
        )
      }

      {
        index !== totalCount && (
          <Divider />
        )
      }
    </React.Fragment>
  )
}
